import { format, isValid, parse } from 'date-fns';

export const CIVIL_DATE_FORMAT = 'yyyy-MM-dd';

const CIVIL_DATE_REG_EXP = /^\d{4}-\d{2}-\d{2}$/;

export function civilDate(value: string): string {
    if (!CIVIL_DATE_REG_EXP.test(value) || !isValid(parse(value, CIVIL_DATE_FORMAT, new Date()))) {
        throw new Error(`"${value}" is not a civil date (${CIVIL_DATE_FORMAT})`);
    }

    return value;
}

export function formatCivilDate(date: Date): string {
    return format(date, CIVIL_DATE_FORMAT);
}

export function parseCivilDate(value: string): Date {
    return parse(value, CIVIL_DATE_FORMAT, new Date());
}
